import { EventTypeCard } from "./EventTypeCard";

export default EventTypeCard;
